import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Storage } from "@/uitls/Storage";
import { onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  name: 'MatchSetting',
  setup(__props, { expose }) {
  expose();

const router = useRouter();

const jinqiu = ref(true);
const jinqiuLoading = ref(true);
const sound = ref(true);
const soundLoading = ref(true);
const animation = ref(true);
const animationLoading = ref(true);

onMounted(() => {
    getData();
});

const getData = () => {
    window.$apiNet.get("app/userMatchSetInfo", {}).then(({ code, data }) => {
        console.log(code, data);
        if (code == 200 && data) {
            jinqiu.value = data.join_push == 1;
            sound.value = data.sound == 1;
            animation.value = data.animation == 1;

            jinqiuLoading.value =
                soundLoading.value =
                animationLoading.value = false;
        }
    });
}

const saveMatchSetting = (key, val) => {
    window.$apiNet.get("app/userMatchSet", {
        set_type: key,
        set_value: val ? 1 : 2
    }).then(({ code, data }) => {
        console.log('data', data);
        
        switch (data.set_type) {
            case 'join_push':
                jinqiuLoading.value = false;
                jinqiu.value = data.set_value == 1;
                break;
            case 'sound':
                soundLoading.value = false;
                sound.value = data.set_value == 1;
                break;
            case 'animation':
                animationLoading.value = false;
                animation.value = data.set_value == 1;
                break;

            default:
                break;
        }
    });
}

const onUpdateJinqiuValue = (val) => {
    jinqiuLoading.value = true;
    saveMatchSetting("join_push", val);
}
const onUpdateSoundValue = (val) => {
    soundLoading.value = true;
    saveMatchSetting("sound", val);
}
const onUpdateAnimationValue = (val) => {
    animationLoading.value = true;
    saveMatchSetting("animation", val);
}


const __returned__ = { router, jinqiu, jinqiuLoading, sound, soundLoading, animation, animationLoading, getData, saveMatchSetting, onUpdateJinqiuValue, onUpdateSoundValue, onUpdateAnimationValue }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})